import { routes } from "router/routes"
import { SettingsCard } from "ui/SettingsCard"
import { isFeatureEnabled } from "config/features"
import { usePermissions } from "hooks/usePermissions"
import { MODULES, ACTIONS } from "utils/permissions"
import { useSelector } from "react-redux"
import styles from "./ProSettings.module.css"

const getSettingsMenuList = (isStaffUser) => [
  {
    name: isStaffUser ? "Profile" : "Business Profile",
    id: "profile-information",
    iconName: "user",
    path: routes.proSettingsProfileInformation(),
    requiresFullAccess: false
  },
  {
    name: "Login & Security",
    id: "login-security",
    iconName: "password",
    path: routes.proSettingsLoginAndSecurity(),
    requiresFullAccess: false
  },
  {
    name: "Branding",
    id: "mode-preferences",
    iconName: "brush",
    path: routes.proSettingsAdventureMode(),
    requiresFullAccess: false
  },
  {
    name: "Payment Providers",
    id: "payment-providers",
    iconName: "card",
    path: routes.proSettingsPaymentProviders(),
    requiresFullAccess: true
  },
  {
    name: "Social Networks",
    id: "social-networks",
    iconName: "link",
    path: "",
    comingSoon: true,
    requiresFullAccess: true
  },
  {
    name: "Licenses",
    id: "licenses",
    iconName: "license",
    path: routes.proSettingsLicenses(),
    requiresFullAccess: true
  },
  {
    name: "Billing",
    id: "billing",
    iconName: "investment",
    path: "",
    comingSoon: true,
    requiresFullAccess: true
  },
  {
    name: "Google Calendar",
    id: "google-calendar",
    iconName: "calendar",
    path: routes.proSettingsGoogleCalendar(),
    requiresFullAccess: true
  },
  {
    name: "Website Integration",
    id: "website-integration",
    iconName: "Code",
    path: routes.proSettingsWebsiteIntegration(),
    requiresFullAccess: true
  },
  {
    name: "Custom Questions",
    id: "custom-questions",
    iconName: "messagesSquare",
    path: routes.proSettingsCustomTemplate(),
    featureFlag: "CUSTOM_TEMPLATE",
    requiresFullAccess: true
  },
   {
    name: "Taxes and Fees",
    id: "taxes-and-fees",
    iconName: "messagesSquare",
    path: routes.proSettingsTaxesAndFees(),
    // featureFlag: "CUSTOM_TEMPLATE"
  },
  {
    name: "Calendar Colors",
    id: "calendar-experience-colors",
    iconName: "calendar",
    path: routes.proSettingsCalendarExperienceColors(),
    requiresFullAccess: true
  }
]

export { getSettingsMenuList }

export const settingsMenuList = getSettingsMenuList(false)

export const ProSettings = () => {
  const { hasPermission } = usePermissions()
  const { role } = useSelector((store) => store.user)
  const isStaffUser = role === "staff_user"
  const settingsMenuList = getSettingsMenuList(isStaffUser)

  const visibleMenuItems = settingsMenuList.filter((menu) => {
    if (menu.featureFlag && !isFeatureEnabled(menu.featureFlag)) {
      return false
    }
    if (menu.requiresFullAccess && !hasPermission(MODULES.SETTINGS, ACTIONS.FULL_ACCESS)) {
      return false
    }

    return true
  })

  return (
    <div className={styles.wrapper}>
      {visibleMenuItems.map((menu) => (
        <SettingsCard key={menu.id} title={menu.name} iconName={menu.iconName} path={menu.path} comingSoon={menu.comingSoon} />
      ))}
    </div>
  )
}
